module.exports = __webpack_public_path__ + "static/media/product.7242e898.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/product.png
// module id = 330
// module chunks = 0